<template>
  <div>


          <p class="template" v-for="paragraph in processed">
            <span v-for="chunk in paragraph">
        <input required type="text" v-model="chunk.value" v-if="chunk.type=='blank'">
        <span  v-if="chunk.type=='text'">{{chunk.value}}</span>
        <select required v-if="chunk.type=='choice'" v-model="chunk.value">
          <option v-for="choice in chunk.choices" :value="choice">{{choice}}</option>
        </select>
      </span>
          </p>

  </div>
</template>

<script>

export default {
  name: 'Blanks',
  data () {
    return {

    }
  },
  props:['processed']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Blanks.vue